export default __webpack_public_path__ + "static/media/text.d12c0e6a.svg";